import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-dashboard-help-dialog',
  templateUrl: './dashboard-help-dialog.component.html',
  styleUrls: ['./dashboard-help-dialog.component.scss']
})
export class DashboardHelpDialogComponent {
  constructor(private readonly dialogRef: MatDialogRef<DashboardHelpDialogComponent>) {}

  close(): void {
    this.dialogRef.close();
  }
}


